module.exports = __webpack_public_path__ + "components/flag/static/square/kr-1ab779ea81c402b5c1568f7b9bc90174.svg";